'use strict'
;(() => {
  window._theme = window._theme || {};
  let egObserver = null, egRules, customizeSettings, savedReminders = [];
  const REMINDER_KEY = 'eg_reminder';
  const EASY_REMINDER_KEY = "EASYGIFT_REMINDER_BANNERS";
  let triggerInitialLoad = true;

  function fetchEGActiveRules() {
    return fetch('https://aca.506.io/public/store?shop=lilacst.myshopify.com')
      .then((res) => res.json())
      .then((res) => {
        egRules = res
        return res
      })
      .catch((err) => {
        console.error('Error while fetching EG app rules data')
        return null
      })
  }

  function watchForModel() {
    const targetNode = document.body

    egObserver = new MutationObserver((mutationsList, observer) => {
      mutationsList.forEach((mutation) => {
        if (mutation.type === 'childList') {
          if(mutation.addedNodes.length) {
            mutation.addedNodes.forEach((node) => {
              if (node.id === 'aca-modal') {
                handleEGModel()
              }
            });
          }
          if(mutation.removedNodes.length) {
            mutation.removedNodes.forEach((node) => {
              if (node.id === 'aca-modal') {
                refreshCart();
              }
            });
          }
        }
      })
    })

    // Configure the observer options
    const config = {
      childList: true, // Watch for adding/removing child nodes
      attributes: false, // Watch for attribute changes
      characterData: false, // Watch for text changes
    }

    // Start observing
    egObserver.observe(targetNode, config)
  }

  function saveSessionData(key, value) {
    const data = typeof value === "string" ? value : JSON.stringify(value);
    sessionStorage.setItem(key, JSON.stringify(data));
  }

  function getSessionData(key) {
    return JSON.parse(sessionStorage.getItem(key) || null)
  }

  function deleteSessionData(key) {
    sessionStorage.removeItem(key);
  }

  function updateLineItem(updates) {
    return fetch('/cart/update.js', {
      method: "post",
      headers: {"Content-Type": "application/json"},
      body: JSON.stringify({updates})
    }).then(res => res.json()).then(res => res).catch(err => err);
  }

  function refreshCart() {
    document.dispatchEvent(new Event('cart:forceRender'));
    document.dispatchEvent(new Event('cart:open'));
  }

  async function handleEGModel() {
    try {
      if (!customizeSettings || !customizeSettings.EG_GWP.enable || !customizeSettings.EG_GWP.ruleId || !egRules.rules) {
        if (egObserver) egObserver.disconnect()
        document.body.classList.remove('hide-eg-model')
        return
      }

      const matchedRule = egRules.rules.find((rule) => rule._id === customizeSettings.EG_GWP.ruleId)
      if (!matchedRule || !matchedRule.active) {
        //if (egObserver) egObserver.disconnect()
        document.body.classList.remove('hide-eg-model')
        return
      }

      const cart = await (window.__lilacCartCache?.getCart
        ? window.__lilacCartCache.getCart()
        : fetch('/cart.js').then((res) => res.json()))
      const total_price = cart.total_price / 100
      const hideModal = total_price < matchedRule.trigger.minCartValue;
      const hasFreeGift = cart.items.find(item => {
        const status = item.properties && item.properties._Gifted && !item.properties._isWelcomeKit && !item.properties.Bundle
        return status;
      });

      document.body.classList.toggle('hide-eg-model', hideModal);
      document.body.classList.toggle('hide-eg-wlcm-model', !hideModal);

      if (hideModal) {
        const modelCloseBtn = document.querySelector('#aca-modal #aca-bottom-close')
        modelCloseBtn && modelCloseBtn.click();

        if(hasFreeGift) {
          updateLineItem({
            [hasFreeGift.key]: 0
          }).then(cart => {
            refreshCart();
          });
        }
      } else {
        const shouldReminder = getSessionData(REMINDER_KEY);
        const reminderElem = document.querySelector(
          `[easygift-reminder-banner-rule="${customizeSettings.EG_GWP.ruleId}"]`
        );
        if(reminderElem) {
          if(triggerInitialLoad || !shouldReminder) {
            triggerInitialLoad = false;
            reminderElem.click();
            saveSessionData(REMINDER_KEY, 'true');
          }
        }
      }
      //if (egObserver) egObserver.disconnect()
      //egObserver = null
    } catch (error) {
      if (egObserver) egObserver.disconnect()
      egObserver = null
      document.body.classList.remove('hide-eg-model')
    }
  }

  document.addEventListener('DOMContentLoaded', (event) => {
    try {
      const jsonData = JSON.parse(document.querySelector('script[data-eggwp-json]').textContent.trim())
      customizeSettings = jsonData
      if (!customizeSettings || !customizeSettings.EG_GWP.enable || !customizeSettings.EG_GWP.ruleId) {
        document.body.classList.remove('hide-eg-model')
        return
      }

      fetchEGActiveRules()
        .then((res) => {
          watchForModel()
          handleEGModel()
        })
        .catch((err) => {
          if (egObserver) egObserver.disconnect()
          document.body.classList.remove('hide-eg-model')
        })
    } catch (error) {
      console.error(error)
    }
  });

  document.addEventListener('EG_MODEL_SHOW', evt => {
    deleteSessionData(REMINDER_KEY);
  });

  window.addEventListener('load', (evt) => {
    if (!customizeSettings || !customizeSettings.EG_GWP.enable || !customizeSettings.EG_GWP.ruleId) {
      document.body.classList.remove('hide-eg-model')
      return
    }

    let count = 0
    function attachEvent() {
      if (count === 80) return
      if (window.EasyGift) {
        window.EasyGift.Events.subscribe('afterCartRequest', (data) => {
          if(data && data.url === "/cart/add.js") deleteSessionData(REMINDER_KEY);
          handleEGModel();
        })
      } else {
        count++
        attachEvent()
      }
    }
    attachEvent()
  })
})()
